'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// ./~/js-yaml/index.js
// module id = 235
// module chunks = 0